<script>
    import { onMount } from 'svelte';
    import Header from '../header.svelte'
    import ResponsiveTable from '../../utils/responsivetable3.svelte';
    import { init_data } from '../../init.js';
    import { referrals_store } from '../../stores.js';
    import { formatDate, sort_functions } from '../../utils/format.js';


    let referrals = [];

    onMount(() => {
        init_data('referrals');
    });

    referrals_store.subscribe(value => {
        let _referrals = [];
        for (let i = 0; i < value.length; i ++) {
            const _referral = value[i];
            _referrals.push({
                'id': _referral.code,
                's': `<a href='#/User_Review?uid=${_referral.sender.id}'>${_referral.sender.first_name} ${_referral.sender.last_name}</a>`,
                'r': `${_referral.recipient_name}<br/>${_referral.recipient_email}`,
                'd': formatDate(_referral.created_at),
                'dt': formatDate(_referral.expiry_at),
                'discount': `${_referral.discount}%`,
                'sa': _referral.is_sender_used ? 'Yes' : 'No',
                'ra': _referral.is_recipient_used ? 'Yes' : 'No',
            });
        }
        referrals = _referrals;
    });

    let table_header_config = [
        {'t': 'Code', 'fm': 'id', 'a': false},
        {'t': 'Sender', 'fm': 's', 'a': true},
        {'t': 'Recipient', 'fm': 'r', 'a': true},
        {'t': 'Created', 'fm': 'd', 'a': true},
        {'t': 'Expiry', 'fm': 'dt', 'a': true},
        {'t': 'Discount', 'fm': 'discount', 'a': true},
        {'t': 'Referral Used (Sender)', 'fm': 'sa', 'a': true},
        {'t': 'Referral Used (Recipient)', 'fm': 'ra', 'a': true},
    ];

    let date_value = '';
</script>

<Header title='Referrals' />

<div class='contentholder'>
    <div class='pagenote'>
        <h3>Note: You can change referral settings in Settings >> <a href='#/Settingsprice'>Pricing</a></h3>
    </div>

    <div class='referralstableholder'>
        <ResponsiveTable
            table_data={referrals}
            num_per_page={100}
            show_date_range={true}
            date_filter_param='dt'
            refresh_action='referrals'
            sort_functions={sort_functions}
            bind:table_header_config={table_header_config}
            bind:date_value={date_value}
            bind:total_items={referrals.length}
        />
    </div>
</div>


<style>
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .contentholder {
            padding: 0px;
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
        }
    }
</style>